import { defineStore } from 'pinia'

export const useTabStore = defineStore('tabs', {
  state: () => ({
    tabs: [
    ],
    activeKey: ''
  }),
  actions: {
    /**
     * 添加标签页
     * @param {string} key 路由路径
     * @param {string} title 标签标题
     */
    addTab(key, title) {
      // 跳过已存在的标签
      if (this.tabs.some(tab => tab.key === key)) {
        this.activeKey = key
        return
      }
      // 添加新标签（默认可关闭）
      this.tabs.push({
        key,
        title: title || '未命名',
        closable: true
      })
      this.activeKey = key
    },
    
    removeTab(key) {
      // 不能关闭首页
      if (key === '/') return;
      
      // 保存当前标签列表的副本用于索引查找
      const originalTabs = [...this.tabs];
      const tabToRemove = originalTabs.find(tab => tab.key === key);
      
      if (!tabToRemove) return;
      
      // 如果关闭的是当前激活标签，需要选择新的激活标签
      if (this.activeKey === key) {
        const currentIndex = originalTabs.indexOf(tabToRemove);
        let newActiveKey;
        
        if (originalTabs.length === 1) {
          // 如果只有一个标签，关闭后跳转到首页
          newActiveKey = '/';
        } else if (currentIndex === originalTabs.length - 1) {
          // 如果关闭的是最后一个标签，激活前一个
          newActiveKey = originalTabs[currentIndex - 1].key;
        } else {
          // 否则激活下一个
          newActiveKey = originalTabs[currentIndex + 1].key;
        }
        
        // 更新激活标签
        this.activeKey = newActiveKey;
      }
      
      // 执行删除操作
      this.tabs = this.tabs.filter(tab => tab.key !== key);
      
      // 确保激活标签存在于当前标签列表中
      if (!this.tabs.some(tab => tab.key === this.activeKey)) {
        this.activeKey = this.tabs.length > 0 ? this.tabs[0].key : '/';
      }
    }
  }
})